import isMobileBrowser from 'is-mobile'
import isPrintMode from 'agency/digital_renderer/utils/isPrintMode'

function deviceStyle(params){
  const { style = {}, mobileStyle = {}, printStyle = {} } = params

  const isMobile = isMobileBrowser()
  const isPrint = isPrintMode()

  const baseStyle = { ...style }
  delete baseStyle.key // remove the key as it is not a valid style property

  // Mobile
  if (isMobile){
    const mergedStyle = {
      ...baseStyle,
      ...mobileStyle,
    }

    delete mergedStyle.key

    return mergedStyle
  }

  // Print
  if (isPrint){
    const mergedStyle = {
      ...baseStyle,
      ...printStyle,
    }

    delete printStyle.key

    return mergedStyle
  }

  return baseStyle
}

export default deviceStyle
